export default "__VITE_ASSET__C3VEaL50__"